module.exports = __webpack_public_path__ + "img/arrows-left.ab493820.svg";